import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class RoleinforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'roleinfor'
    }


    /**
     * 根据子系统id查询角色数据
     * @returns 
     */
    public getListBySubId(subSystemId, projectId, searchText) {
        return this.send({ subSystemId: subSystemId, projectId: projectId, roleName: searchText }, "getListBySubId", Methods.GET)
    }

    /**
     * 根据项目Id获取角色
     * @param projectId 
     * @returns 
     */
    public getFlowRoleVoes(projectId) {
        return this.send({ projectId }, "getFlowRoleVoes", Methods.GET);
    }
    /**
     * 分页列表
     * @param projectId
     * @returns
     */
    public getEntitiesPage() {
        return this.send({ size:100,current:1 }, "getEntitiesPage", Methods.GET);
    }

}
